import { render, staticRenderFns } from "./QuickviewInquiries.vue?vue&type=template&id=2dd16356&scoped=true&"
import script from "./QuickviewInquiries.vue?vue&type=script&lang=js&"
export * from "./QuickviewInquiries.vue?vue&type=script&lang=js&"
import style0 from "./QuickviewInquiries.vue?vue&type=style&index=0&id=2dd16356&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd16356",
  null
  
)

export default component.exports